<template>
  <div class="sa-dialog">
    <div class="sa-dialog-body sa-extra-small sa-text-center">
        <i class="icon-logo-symbol sa-f-size30"></i>
      <p v-if="data && data.txt">{{data.txt}}</p>
      <div class="sa-ftr-btn sa-mt15">
            <button v-if="data && data.btn1" class="sa-btn sa-btn-primary sa-btn-block" @click="update">{{data.btn1}}</button>
            <button v-if="data && data.btn2" @click="$parent.updateApp = false" class="sa-btn sa-btn-default sa-btn-block sa-mt15" >{{data.btn2}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["data"],
  data() {
    return {
    };
  },
  methods:{
    update(){
      window.open(this.data.url)
    }
  }
};
</script>